import React from 'react';
import { InputContainer } from '../../../../../common/components/form/input/containers/input.container';

export const WebsitesBasicInfoComponent = ({ departments, stores, onInnerFormChange, selectedTenantWebsites, websites }: any) => (

  <>
    <div className=' grid md:grid-cols-3 lg:grid-cols-4 gap-4'>
      <InputContainer
        label="Template"
        labelField="WebsiteName"
        list={websites}
        onValueChange={(event: any, newValue: any) => {
          onInnerFormChange(
            event.target.value,
            'PlatformWebSiteId',
          );
        }}
        optionName='Choose Platform Websites'
        type="select"
        value={selectedTenantWebsites?.PlatformWebSiteId}
        valueField="Id"
      />
      <InputContainer
        label="Store"
        labelField="StoreName"
        list={stores}
        onValueChange={(event: any, newValue: any) => {
          onInnerFormChange(
            event.target.value,
            'StoreId',
          );
        }}
        optionName='Choose Store'
        type="select"
        value={selectedTenantWebsites?.StoreId}
        valueField="Id"
      />
      <InputContainer
        label="Department"
        labelField="Name"
        list={departments}
        onValueChange={(event: any, newValue: any) => {
          onInnerFormChange(
            event.target.value,
            'DepartmentId',
          );
        }}
        optionName='Choose Department'
        type="select"
        value={selectedTenantWebsites?.DepartmentId}
        valueField="Id"
      />
      <InputContainer

        label="WebSite Name"
        name="WebSiteName"
        onValueChange={(event: any) => {
          onInnerFormChange(
            event.target.value,
            'WebSiteName',

          )
        }}
        type="text"
        value={selectedTenantWebsites?.WebSiteName}
      />
      <InputContainer

        label="WebSite Version"
        name="WebSiteVersionId"
        onValueChange={(event: any) => {
          onInnerFormChange(
            event.target.value,
            'WebSiteVersionId',

          )
        }}
        type="number"
        value={selectedTenantWebsites?.WebSiteVersionId}
      />
      <InputContainer

        label="Hosting Url"
        name="HostingUrl"
        onValueChange={(event: any) => {
          onInnerFormChange(
            event.target.value,
            'HostingUrl',

          )
        }}
        type="text"
        value={selectedTenantWebsites?.HostingUrl}
      />
      <InputContainer

        label="FQDN Name"
        name="FQDNName"
        onValueChange={(event: any) => {
          onInnerFormChange(
            event.target.value,
            'FQDNName',

          )
        }}
        type="text"
        value={selectedTenantWebsites?.FQDNName}
      />
      <InputContainer

        label="Mapped Domain"
        name="MappedDomain"
        onValueChange={(event: any) => {
          onInnerFormChange(
            event.target.value,
            'MappedDomain',

          )
        }}
        type="text"
        value={selectedTenantWebsites?.MappedDomain}
      />
      <InputContainer

        label="Display Order"
        name="DisplayOrder"
        onValueChange={(event: any) => {
          onInnerFormChange(
            event.target.value,
            'DisplayOrder',

          )
        }}
        type="number"
        value={selectedTenantWebsites?.DisplayOrder}
      />
      <InputContainer

        label="Remarks"
        name="Remarks"
        onValueChange={(event: any) => {
          onInnerFormChange(
            event.target.value,
            'Remarks',

          )
        }}
        type="text"
        value={selectedTenantWebsites?.Remarks}
      />

    </div>
  </>
)
